<template>
  <div class="page">

    <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadData"
        class="list">
      <div v-for="(item, index) in list" :key="index" class="listItem">
        <div class="line1">
          <div class="title">{{ item.actionName }}</div>
          <div class="amount" :style="item.type? 'color: #ff9204' : ''">{{ item.type ? '+' : '-' }}{{ divide100(item.changeAmount) }}</div>
        </div>
        <div class="line2">
          <div class="data">{{ formatDate(item.createTime, 'YYYY-MM-DD HH:mm') }}</div>
          <div class="toDetail" @click="$router.push('/clerk/order/detail/'+item.orderId)" v-if="item.action==='assigned_order'|| item.action==='reward_order'">
            查看详情
            <div class="arrow"> ></div>
          </div>
        </div>
      </div>
    </van-list>

  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, List, Toast} from "vant"
import moment from "moment";
import {handlePromise} from "@/libs/util";
import {getList} from "../../../api/clerk/clerk-points-log";
import Decimal from "decimal.js";
import {getPointPrizeList} from "../../../api/clerk/clerk-point-prize";

Vue.use(List)


export default {
  name: "signInDetail",

  data() {
    return {
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 20,
      list: []
    }
  },

  methods: {
    divide100(amount) {
      return Decimal.div(amount, 100).toNumber()
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },

    loadData(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
        this.list = []
      }
      this.loading = true
      handlePromise(getList(this.pageNo, this.pageSize), (data) => {
        this.loading = false
        this.list = this.list.concat(data.list)
        this.finished = !data.hasNextPage
        this.pageNo++
      }, (data) => {
        this.loading = false
        Dialog.alert({title: '加载失败', message: data.msg})
      })
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style scoped lang="less">
.page {
  padding: 2vw 4vw 0;
  box-sizing: border-box;

  .list {

    .listItem {
      padding: 2.6vw 0;

      .line1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 3.7vw;
        color: #333;
        margin-bottom: 2.4vw
      }

      .line2 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 2.9vw;
        color: #B3B3B3;
        line-height: 1;

        .toDetail {
          display: flex;
          align-items: center;

          .arrow {
            margin-left: 2vw;
            transform: scale(.7, 1.4);
          }
        }
      }
    }
  }
}
</style>